import './Delete.scss';

export { default } from './Delete';
